import { render, staticRenderFns } from "./ReportMissingEvent.vue?vue&type=template&id=136dc3d9&"
import script from "./ReportMissingEvent.vue?vue&type=script&lang=ts&"
export * from "./ReportMissingEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports